// @ts-nocheck
import { interpolateCurveValues, interpolateCurveValuesNoDates } from "../../../api/awsLamba";
import { calculatePercentile } from "../../../util/utils";

// Craig Change Name Obviously
export const formatPowerEnsembleToPercentile =(windMagnitudeGEFS80, sortedCurveData)=> {
    const percentiles = [10, 30, 50, 70, 90]
    return Object.keys(windMagnitudeGEFS80).reduce((acc, datekeys)=> {
    const windensembles = windMagnitudeGEFS80[datekeys]
    // pop control 
    const windCtrl = windensembles.pop()
    const [windPowerCtrl] = interpolateCurveValuesNoDates(
      sortedCurveData,
      [windCtrl]
    );
    const ensemblePowerArray = interpolateCurveValuesNoDates(
      sortedCurveData,
      windensembles
    );
    // console.log(datekeys, ensemblePowerArray)
    const percentileDataGEFS = percentiles.reduce((accPCTL, pctl) => {
      const pctlVal = calculatePercentile(ensemblePowerArray, pctl);
      return {...accPCTL, [`p${pctl}`]: pctlVal}
    }, {});
    const mean = ensemblePowerArray.reduce((a,b) =>a+b)/30
    const dataChannels = {...percentileDataGEFS, mean, control: windPowerCtrl }
    return {...acc, [datekeys]: dataChannels}
  },{})
}

export const timePowerDataToPercentile = (rawData) =>{
const result = {
    control: [],
    mean: [],
    p10: [],
    p30: [],
    p50: [],
    p70: [],
    p90: [],
  };

  Object.entries(rawData).forEach(([timestamp, dataPoint]) => {
    const isoDate = new Date(Number(timestamp)).toISOString();
    
    // For each expected key, push a { x, y } pair into the result
    for (const key in result) {
      if (dataPoint.hasOwnProperty(key)) {
        result[key].push({ x: isoDate, y: dataPoint[key] });
      }
    }
  });

  return result;
}
